/* eslint-disable react/boolean-prop-naming */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack, {StackProps} from '@mui/material/Stack';

import {RouterLink} from 'src/routes/components';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

interface Props extends StackProps {
  title: string;
  subTitle?: string;
  secondaryTitle?: any;
  addButton?: boolean;
  link?: string;
  onOpen?: VoidFunction;
  collapse?: boolean;
  onCollapse?: VoidFunction | any;
}

export default function DropDownPanel({
  title,
  subTitle,
  secondaryTitle,
  addButton,
  link,
  onOpen,
  collapse,
  onCollapse,
  children,
  sx,
  ...other
}: Props) {
  return (
    <Stack direction="column" sx={{...sx}} {...other}>
      <Stack direction="row" alignItems="center" sx={{...sx}} {...other}>
        <Stack flexGrow={1}>
          <Stack direction="row" justifyContent={'space-between'}>
            <Stack direction="row" alignItems="center" spacing={1} flexGrow={1}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '18px !important'
                }}>
                {title}
              </Typography>

              {onCollapse && (
                <IconButton
                  size="small"
                  color="primary"
                  onClick={onCollapse}
                  sx={{
                    width: 24,
                    height: 24,
                    bgcolor: 'primary.dark',
                    color: 'primary.contrastText',
                    '&:hover': {
                      bgcolor: 'primary.main'
                    }
                  }}>
                  {/* <Iconify icon="mingcute:add-line" /> */}
                  <Iconify
                    icon={
                      collapse
                        ? 'eva:arrow-ios-downward-fill'
                        : 'eva:arrow-ios-upward-fill'
                    }
                  />
                </IconButton>
              )}
            </Stack>

            {secondaryTitle && !collapse && secondaryTitle}
          </Stack>

          {subTitle && (
            <Box sx={{typography: 'body2', color: 'text.disabled', mt: 0.5}}>
              {subTitle}
            </Box>
          )}
        </Stack>

        {link && (
          <Button
            href={link}
            component={RouterLink}
            size="small"
            color="inherit"
            endIcon={
              <Iconify
                icon="eva:arrow-ios-forward-fill"
                width={18}
                sx={{ml: -0.5}}
              />
            }>
            View All
          </Button>
        )}
      </Stack>
      {!collapse && children}
    </Stack>
  );
}
